<style>
@import url("./assets/bower_components/bootstrap/dist/css/bootstrap.min.css");
@import url("./assets/bower_components/datatables.net-bs/css/dataTables.bootstrap.min.css");
@import url("./assets/bower_components/font-awesome/css/font-awesome.min.css");
@import url("./assets/bower_components/Ionicons/css/ionicons.min.css");
@import url("./assets/dist/css/skins/_all-skins.min.css");
@import url("./assets/bower_components/morris.js/morris.css");
@import url("./assets/bower_components/jvectormap/jquery-jvectormap.css");
@import url("./assets/bower_components/bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css");
@import url("./assets/bower_components/bootstrap-daterangepicker/daterangepicker.css");
@import url("./assets/plugins/bootstrap-wysihtml5/bootstrap3-wysihtml5.min.css");
@import url("vue-good-table/dist/vue-good-table.css");
@import url("./assets/dist/css/AdminLTE.css");
</style>

<template>
<div id="app">

    <Cabezera v-bind:class="classObject"></Cabezera>
    <Derecha v-bind:class="classObject"></Derecha>

    <router-view></router-view>
    <Pie v-bind:class="removeFooter"></Pie>
</div>
</template>

<script>
export default {
  name: "app",
  mounted() {
    localStorage.setItem("skin", "skin-red-light");
  },
  computed: {
    removeFooter: function() {
      if (this.$route.name == "uptimeRobot") return "hide";

      return "visible";
    },
    classObject: function() {
      if (
        this.$route.name == "login" ||
        this.$route.name == "uptimeRobot" ||
        this.$route.name == "forgot-password" ||
        this.$route.name == "passwordtokenverification" ||
        this.$route.name == "approved" ||
        this.$route.name == "rejectExplaining" ||
        this.$route.name == "NotFound"
      )
        return "hide";

      return "visible";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/App.vue